import { loginBouncedRequestQuery } from 'bff/schemas/auth'
import { useTranslation } from 'i11n/client'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useToast } from 'ui/use-toast'
import { z } from 'zod'

const searchParamsSchema = loginBouncedRequestQuery

export const useCallbackError = () => {
  const { toast } = useToast()

  const t = useTranslation()

  const searchParams = useSearchParams()

  return {
    catchErrors: () => {
      const searchParamsParsed = searchParamsSchema.safeParse(
        Object.fromEntries(searchParams),
      )

      if (searchParamsParsed && searchParamsParsed.data?.error_code) {
        toast({
          title: t(
            `api_errors.${searchParamsParsed.data.error_code}.title`,
            searchParamsParsed.data,
          ),
          description: t(
            `api_errors.${searchParamsParsed.data.error_code}.description`,
            searchParamsParsed.data,
          ),
          variant: 'destructive',
        })
      }
    },
  }
}
